import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultAddCard = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
